// extracted by mini-css-extract-plugin
export var cardIcon = "_9t-5";
export var cardIconUnframed = "_9t-9";
export var checkboxCard = "_9t-0";
export var checkboxCardSelected = "_9t-4";
export var disabled = "_9t-2";
export var interactive = "_9t-1";
export var outerBorder = "_9t-3";
export var spacerMedium = "_9t-8";
export var spacerSmall = "_9t-7";
export var spacerXsmall = "_9t-6";